import React from 'react'
import { Section, GuideHeader, P, UI, Steps, Bullets, Callout, RoleTag } from './GuideParts'

export default function ApprovalsGuide() {
  return (
    <div className="space-y-8">
      <GuideHeader
        title="Approvals"
        intro="Requests that have been extracted and are waiting for a person to check and approve them."
      />

      <Section number={1} title="What the Approvals Page Shows">
        <P>
          <UI>Approvals</UI> uses the same list design as Requests, but only shows requests waiting for review.
          Each row shows the request, its template, its status and who it is <UI>Assigned To</UI>. Use <UI>Refresh</UI> to reload the list.
          When nothing is waiting you see “All caught up!”.
        </P>
        <Callout kind="info">
          People with the Reviewer role do not see this page. They send requests for review but do not approve them.
        </Callout>
      </Section>

      <Section number={2} title="Reviewing a Request">
        <RoleTag roles={['Approver', 'Template Manager', 'Admin']} />
        <Steps>
          <li>Find the request in the list and start the review. Your own rows have a start-review action.</li>
          <li>The request opens with the document on one side and the extracted fields on the other. Fields with low AI confidence are flagged, check those first.</li>
          <li>Correct any wrong value and choose <UI>Save</UI>. Use <UI>Discard Changes</UI> to go back to what the AI extracted.</li>
          <li>Choose <UI>Approve and publish</UI>. The approved data is sent to the connectors and output destinations set up on the template.</li>
        </Steps>
        <P>
          If a request should not go any further, use <UI>Cancel Request</UI> on the request page.
        </P>
      </Section>

      <Section number={3} title="Assigning an Approver">
        <RoleTag roles={['Admin']} />
        <P>
          Admins get an <UI>Assign</UI> dropdown on each row. The list offers people who can approve, so Reviewers are not shown.
          If your organisation uses OpCos, only members of the request’s OpCo can be chosen.
        </P>
        <P>
          When a person is deactivated from Users &amp; Groups, the approvals open on them are released so someone else can pick them up.
        </P>
      </Section>

      <Section number={4} title="Who Can Approve">
        <Bullets>
          <li>Admins, Template Managers and Approvers can approve and publish.</li>
          <li>Reviewers can send a request for review with <UI>Send for Review</UI>, but not publish it.</li>
          <li>A Reader can open requests but cannot change or approve them.</li>
          <li>Some templates use an external review. Those requests show a different set of buttons to people who are not Admins.</li>
        </Bullets>
      </Section>
    </div>
  )
}
